import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";import moment from "moment";
import {
  currencyActionId,
  downloadReport,
  hsncodeActionId,
  sessionExpireMessage,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import Header from "../../../common_components/Header";
import {
  credit_note_add_action,
  credit_note_detail_order_action,
  credit_note_detail_action,
  download_creditNote_action,
} from "../../../actions/accounts_action/account_credit_note_action";
class AccountCreditNoteAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      userId: "",
      OrderID: "",
      ClientID: "",
      CreditNoteID: "",
      CreditNoteNo: "",
      CreditNoteDate: "",
      CompanyName: "",
      Address: "",
      GSTNo: "",
      CurrencyID: "",
      Currency: "",
      OrderNo: "",
      Remark: "",
      PrimaryEmailID: "",
      selectedHSNCode: "",
      currencyFillList: [],
      hsnFillList: [],
      udtList: [],
      udtDetail: {
        SrNo: "",
        Narration: "",
        HSNCode: "",
        GST: "",
        Price: "",
        Quantity: "",
        Amount: "",
      },
      editedRowIndex: null,
      editedRowData: {},
      showNewRow: false,
      creditNoteData: [],
      RoleID:"",
    };
    this.backCreditNote = this.backCreditNote.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getDetailsFromOrder = this.getDetailsFromOrder.bind(this);
    this.getDetailsFromEdit = this.getDetailsFromEdit.bind(this);
  }
  componentDidMount() {
    const { userId } = this.state;
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
    this.setState({
      OrderID:
        this.props.location.state != null &&
        this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      PrimaryEmailID:
        this.props.location.state != null &&
        this.props.location.state.PrimaryEmailID != null
          ? this.props.location.state.PrimaryEmailID
          : "",
          RoleID:
        this.props.location.state != null &&
        this.props.location.state.RoleID != null
          ? this.props.location.state.RoleID
          : "",
    });
    console.log("propsState", this.props.location.state);
    const OrderID = this.props.location.state?.OrderID || "";
    const CreditNoteID = this.props.location.state?.CreditNoteID || "";
    console.log("OrderID & CreditNoteID", OrderID, CreditNoteID);
    const isEdit=this.props.location.state?.isEdit||0;
    if (OrderID) {
      this.setState({ OrderID,isEdit }, () => {
        this.getDetailsFromOrder();
      });
    }
    if (CreditNoteID) {
      this.setState({ CreditNoteID,isEdit }, () => {
        this.getDetailsFromEdit();
      });
    }
    this.getFillList(currencyActionId, userId, "", "");
    this.getFillList(hsncodeActionId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "FillList");
        if (data.error != 1) {
          if (value == currencyActionId) {
            this.setState({ currencyFillList: data.data, isLoading: false });
          }
          if (value == hsncodeActionId) {
            this.setState({ hsnFillList: data.data, isLoading: false });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  backCreditNote() {
    this.props.navigate("/creditNoteList");
  }
  backToOrderEdit(OrderID, ClientID) {
    this.props.navigate("/orderEdit", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
      },
    });
  }
  handleAddRowUDT() {
    const { udtList, udtDetail } = this.state;
    if(udtDetail.Narration==""){
      toast.error("Please Enter Narration",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.HSNCode==""||udtDetail.HSNCode==null){
      toast.error("Please Select HSN Code",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.Price==""){
      toast.error("Please Enter Price",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.Quantity==""){
      toast.error("Please Enter Quantity",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else{
      const newRow = { ...udtDetail, SrNo: udtList.length + 1 };
      this.setState({
        udtList: [...udtList, newRow],
        udtDetail: {
          SrNo: udtList.length + 2,
          Narration: "",
          HSNCode: "",
          GST: "",
          Price: "",
          Quantity: "",
          Amount: "",
        },
        showNewRow: false,
      });
    }
  }
  toggleNewRow() {
    this.setState((prevState) => ({
      showNewRow: !prevState.showNewRow,
    }));
  }
  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowUDT();
    }
  }
  handleEditRow(index, data) {
    this.setState({
      editedRowIndex: index,
      editedRowData: { ...data },
    });
  }
  handleRowEditFieldChange(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowData };
    editedDataCopy[field] = value;
    
    if (field === "Price" || field === "Quantity") {
      editedDataCopy.Amount = editedDataCopy.Price * editedDataCopy.Quantity;
    }
    this.setState({ editedRowData: editedDataCopy });
  }

  saveEditedRow(index) {
    const { udtList, editedRowData } = this.state;
    if(editedRowData.Narration==""){
      toast.error("Please Enter Narration",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.HSNCode==""||editedRowData.HSNCode==null){
      toast.error("Please Select HSN Code",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.Price==""){
      toast.error("Please Enter Price",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.Quantity==""){
      toast.error("Please Enter Quantity",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else{
    const updatedList = [...udtList];
    updatedList[index] = editedRowData;
    this.setState({
      udtList: updatedList,
      editedRowIndex: null,
      editedRowData: {},
    });
  }
  }
  cancelEditRow() {
    this.setState({
      editedRowIndex: null,
      editedRowData: {},
    });
  }
  handleDeleteRow(index) {
    const { udtList } = this.state;
    const updatedList = [...udtList];
    updatedList.splice(index, 1); // Remove the row at the specified index
    this.setState({
      udtList: updatedList,
    });
  }
  getDetailsFromOrder() {
    const { userId ,OrderID} = this.state;
    console.log(userId, OrderID, "const console");
    if (OrderID) {
      this.props
        .credit_note_detail_order_action(userId, OrderID)
        .then((data) => {
          console.log("credit from order details-----", data);
          if (data.error !== 1) {
            this.setState({
              CreditNoteID: data.data[0]["CreditNoteID"],
              CreditNoteNo: data.data[0]["CreditNoteNo"],
              CreditNoteDate: moment(data.data[0]["CreditNoteDate"]).format('DD-MM-YYYY'),
              CompanyName: data.data[0]["CompanyName"],
              Address: data.data[0]["Address"],
              GSTNo: data.data[0]["GSTNo"],
              CurrencyID: data.data[0]["CurrencyID"],
              Currency: data.data[0]["Currency"],
              OrderNo: data.data[0]["OrderNo"],
              ClientID: data.data[0]["ClientID"],
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.data, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toast.error("details not found", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  }
  getDetailsFromEdit() {
    const { userId } = this.state;
    const CreditNoteID = this.props.location.state.CreditNoteID;

    if (CreditNoteID) {
      this.props
        .credit_note_detail_action(userId, CreditNoteID)
        .then((response) => {
          if (response.error !== 1) {
            const data = response.data; // Extract data from the API response

            this.setState({
              CreditNoteID: data[0][0]["CreditNoteID"],
              CreditNoteNo: data[0][0]["CreditNoteNo"],
              CreditNoteDate: moment(data[0][0]["CreditNoteDate"]).format('DD-MM-YYYY'),
              CompanyName: data[0][0]["CompanyName"],
              Address: data[0][0]["Address"],
              GSTNo: data[0][0]["GSTNo"],
              CurrencyID: data[0][0]["CurrencyID"],
              Currency: data[0][0]["Currency"],
              OrderNo: data[0][0]["OrderNo"],
              ClientID: data[0][0]["ClientID"],
              Remark: data[0][0]["Remark"],
              OrderID: data[0][0]["OrderID"],
              udtList: data[1], // Assign the array from data[1] to amountArr
            });
            console.log("1st index", data[1]);
          } else {
            if(response.msg == sessionExpireMessage || response.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(response.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(response.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      toast.error("Details for edit not found", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  }

  handleHSNCodeChange = (index, selectedHSNCode) => {
    // Update the selected HSNCode in the state
    this.setState({
      selectedHSNCode,
    });
  };

  handleSubmit() {
    const {
      userId,
      CreditNoteID,
      CreditNoteNo,
      CreditNoteDate,
      OrderNo,
      CompanyName,
      Address,
      GSTNo,
      CurrencyID,
      Remark,
      udtList,
      OrderID,
      ClientID,
      PrimaryEmailID,
    } = this.state;
    console.log(udtList,CurrencyID,"CurrencyID")
    if(udtList.length===0){
      console.log("this")
      toast.error("Kindly Fill Credit Note",{
        position:"top-center",
        theme:"colored",
        autoClose:2000,
        hideProgressBar: true,
      })
    }else{
console.log(OrderID,'submit ORderID')
    this.setState({ isLoading: true });
    this.props
      .credit_note_add_action(
        userId,
        CreditNoteID,
        CreditNoteNo,
        CreditNoteDate,
        OrderNo,
        CompanyName,
        Address,
        GSTNo,
        CurrencyID,
        Remark,
        udtList,
        OrderID,
        ClientID,
        PrimaryEmailID
      )
      .then((data) => {
        console.log(data, "update");
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Data Updated Successfully", {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.props.navigate("/creditNoteList");
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          this.setState({ isLoading: false });
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    }
  }
  downloadCreditNote(CreditNoteID, CreditNoteNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (CreditNoteID) {
      console.log(CreditNoteID, CreditNoteNo);
      const formattedCreditNoteNo = CreditNoteNo.replace(/[\/-]/g, "_");
      this.props
        .download_creditNote_action(userId, CreditNoteID, formattedCreditNoteNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if(downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false });
            toast.error(downloadData.msg,{
              position:"top-center",
            theme:"colored",autoClose:1000,hideProgressBar:true});
          }}
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: CreditNoteID not found.",{
        position:"top-center",
      theme:"colored",autoClose:1000,hideProgressBar:true});
    }
  }
  render() {
    const {
      isLoading,
      isAccordionExpanded,
      OrderID,
      OrderNo,
      ClientID,
      CreditNoteDate,
      CreditNoteNo,
      CompanyName,
      Address,
      GSTNo,
      Currency,
      CurrencyID,
      currencyFillList,
      SrNo,
      Narration,
      HSNCode,
      GST,
      Price,
      Quantity,
      Amount,
      udtList,
      udtDetail,
      editedRowIndex,
      editedRowData,
      hsnFillList,
      selectedHSNCode,
      showNewRow,CreditNoteID,
      Remark
    } = this.state;
    const udtListWithAmount = udtList.map((data) => ({
      ...data,
      Amount: data.Price * data.Quantity,
    }));
    // Calculate the "Total Amount" by summing the "Amount" from each row
    const totalAmount = udtList.reduce(
      (total, row) => total + parseFloat(row.Amount || 0),
      0
    );

    // Calculate the "GST Amount" by summing the product of "GST" and "Amount" from each row
    const gstAmount = udtList.reduce(
      (total, row) =>
        total + (parseFloat(row.GST || 0) * parseFloat(row.Amount || 0)) / 100,
      0
    );
    const orderIDorCreditID =
      this.props.location.state.CreditNoteID ||
      this.props.location.state.OrderID;
      const isEdit=this.props.location.state.isEdit||0
      
    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              <Header data={[12]} />

              <section style={{ marginTop: "115px" }}>
                <div class="container-fluid">
                  <div class="page-header">
                    <h4 class="page-title">{isEdit==1?"Edit":"Add"} Credit Note</h4>
                    {isEdit==1?(<div className="row">
                      <div>
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            this.downloadCreditNote(
                              orderIDorCreditID,
                              CreditNoteNo
                            )
                          }
                          class="btn btn-success btn-sm fs-12"
                        >
                          <i class="fa fa-download"></i> Download
                        </a>
                      </div>
                      <div className="mx-2">
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            this.downloadCreditNote(
                              orderIDorCreditID,
                              CreditNoteNo
                            )
                          }
                          class="btn btn-warning btn-sm fs-12"
                        >
                          <i class="fa fa-envelope"></i> Email
                        </a>
                      </div>
                    </div>):(<></>)}
                  </div>
                  <div class="card Service_fields">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Credit Note No</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              value={CreditNoteNo}
                              onChange={(e) =>
                                this.setState({ CreditNoteNo: e.target.value })
                              }
                              disabled
                              placeholder="Enter Credit Note No"
                            />
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Credit Note Date</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Credit Note Date"
                              value={CreditNoteDate}
                              onChange={(e) =>
                                this.setState({
                                  CreditNoteDate: e.target.value,
                                })
                              }
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="row">
                            <div class="col-md-8"></div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Order Reference</label>
                                <input
                                  type="text"
                                  class="form-control search_form_control"
                                  placeholder="Order Reference"
                                  value={OrderNo}
                                  disabled
                                  onChange={(e) =>
                                    this.setState({ OrderNo: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Company</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Company"
                              value={CompanyName}
                              onChange={(e) =>
                                this.setState({ CompanyName: e.target.value })
                              }
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Company Address</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Company Address"
                              value={Address}
                              onChange={(e) =>
                                this.setState({ Address: e.target.value })
                              }
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>GST No</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter GST No"
                              disabled
                              value={GSTNo}
                              onChange={(e) =>
                                this.setState({ GSTNo: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Currency (USD / INR)</label>
                            <select
                              class="form-control"
                              value={CurrencyID}
                              onChange={(e) => {
                                const selectedCurrency = e.target.value;
                                this.setState({ CurrencyID: selectedCurrency });
                              }}
                              disabled
                            >
                              <option>--SELECT--</option>
                              {currencyFillList.length > 0 &&
                                currencyFillList.map((data) => (
                                  <option key={data.ID} value={data.ID}>
                                    {data.Currency}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="custom_table">
                            <div class="hack1 card mb-3">
                              <div
                                class="hack2 card-body"
                                style={{ background: "#f8f8f8" }}
                              >
                                <table
                                  class="table table-bordered table-striped"
                                  id="dashboard-table"
                                >
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>Narration</th>
                                      <th>HSN Code</th>
                                      <th>GST %</th>
                                      <th>Price</th>
                                      <th>Quantity</th>
                                      <th>Amount</th>
                                      {this.props.location.state.RoleID === 3?null:
                                      <th
                                      class="text-right"
                                      style={{ width: "8%" }}
                                      >
                                        Action
                                      </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody id="myTable">
                                    {udtListWithAmount.length > 0 ? (
                                      udtListWithAmount.map((data, index) => (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Narration
                                                    : data.Narration
                                                }
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Narration",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              data.Narration
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <select
                                                className="form-control"
                                                name="HSNCode"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.HSNCode
                                                    : data.HSNCode
                                                }
                                                onChange={(e) =>
                                                  this.handleHSNCodeChange(
                                                    index,
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                <option value="">
                                                  --Select--
                                                </option>
                                                {hsnFillList.map((data) => (
                                                  <option
                                                    key={data.HSNCode}
                                                    value={data.HSNCode}
                                                  >
                                                    {data.HSNCode}
                                                  </option>
                                                ))}
                                              </select>
                                            ) : (
                                              data.HSNCode
                                            )}
                                          </td>

                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={`${editedRowData.GST}%`}
                                                disabled
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "GST",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              // Display the selected GST based on the state
                                              `${
                                                hsnFillList.find(
                                                  (item) =>
                                                    item.HSNCode ===
                                                    this.state.selectedHSNCode
                                                )?.GST || data.GST
                                              }%`
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Price
                                                    : data.Price
                                                }
                                                onChange={(e) =>{
                                                  const value = e.target.value;
                                               
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                    this.handleRowEditFieldChange(
                                                      index,
                                                      "Price",
                                                     numericValue
                                                    )
                                                  } 
                                                }
                                              />
                                            ) : (
                                              data.Price?.toLocaleString(
                                                "en-IN"
                                              )
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Quantity
                                                    : data.Quantity
                                                }
                                                onChange={(e) =>{
                                                  const value = e.target.value;
                                             
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Quantity",
                                                    numericValue
                                                  )}}
                                              />
                                            ) : (
                                              data.Quantity
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={editedRowData.Amount}
                                                disabled={true}
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Amount",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              data.Amount?.toLocaleString(
                                                "en-IN"
                                              )
                                            )}
                                          </td>
                                          {this.props.location.state.RoleID === 3?null:
                                          <td className="text-right">
                                            {editedRowIndex === index ? (
                                              <>
                                                <a
                                                  title="Save"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.saveEditedRow(index)
                                                  }
                                                >
                                                  <i className="fa fa-save action_btn_table" />
                                                </a>
                                                <a
                                                  title="Cancel"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.cancelEditRow()
                                                  }
                                                >
                                                  <i className="fa fa-times action_btn_table" />
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                <a
                                                  title="Edit"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.handleEditRow(
                                                      index,
                                                      data
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-edit action_btn_table" />
                                                </a>
                                                <a
                                                  title="Delete"
                                                  className="btn btn-sm delete_record padding_0"
                                                  onClick={() =>
                                                    this.handleDeleteRow(index)
                                                  }
                                                >
                                                  <i className="fa fa-trash action_btn_table" />
                                                </a>
                                              </>
                                            )}
                                          </td>
  }
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="8">No data available.</td>
                                      </tr>
                                    )}
                                    {showNewRow && (
                                      <tr>
                                        <td></td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Narration}
                                            onChange={(e) =>
                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  Narration: e.target.value,
                                                },
                                              })
                                            }
                                          />
                                        </td>
                                        <td>
                                          <select
                                            className="form-control col-md-12"
                                            name="HSNCode"
                                            value={udtDetail.HSNCode}
                                            onChange={(e) => {
                                              const selectedHSNCode =
                                                e.target.value;
                                              const selectedGST =
                                                hsnFillList.find(
                                                  (item) =>
                                                    item.HSNCode ===
                                                    selectedHSNCode
                                                )?.GST || "";

                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  HSNCode: selectedHSNCode,
                                                  GST: selectedGST,
                                                },
                                              });
                                            }}
                                          >
                                            <option value="">--Select--</option>
                                            {hsnFillList.map((data) => (
                                              <option
                                                key={data.HSNCode}
                                                value={data.HSNCode}
                                              >
                                                {data.HSNCode}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={`${udtDetail.GST}%`}
                                            disabled
                                          />
                                        </td>

                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Price?.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                this.setState({
                                                  udtDetail: {
                                                    ...udtDetail,
                                                    Price: numericValue,
                                                    Amount:
                                                      numericValue *
                                                      udtDetail.Quantity, // Calculate "Amount"
                                                  },
                                                })
                                              }
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Quantity}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  Quantity: numericValue,
                                                  Amount:
                                                    udtDetail.Price *
                                                    numericValue, // Calculate "Amount"
                                                },
                                              })}}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Amount?.toLocaleString(
                                              "en-IN"
                                            )}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="text-right">
                                          <button
                                            className="btn btn-primary btn-md"
                                            onClick={() =>
                                              this.handleAddRowUDT()
                                            }
                                          >
                                            Add
                                          </button>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                                {this.props.location.state.RoleID === 3?null:
                                <div>
                                  <a
                                    href="javascript:void(0);"
                                    class="btn btn-primary btn-sm create_btn add_new_table_btn"
                                    style={{ width: "auto" }}
                                    onClick={() => this.toggleNewRow()}
                                  >
                                    <span class="hidden-xs">
                                      {showNewRow ? "Cancel" : "Add"}
                                    </span>
                                  </a>
                                </div>
  }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom_table">
                            <table
                              class="table table-bordered table-striped"
                            >
                              <tbody id="myTable">
                                <tr>
                                  <td>Total Amount</td>
                                  <td>{totalAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                  <td>GST Amount</td>
                                  <td>{gstAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                  <td>Total Payable</td>
                                  <td>
                                    {(totalAmount + gstAmount).toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Remark</label>
                            <textarea
                              class="form-control"
                              rows="3"
                              placeholder="Type here..."
                              value={Remark}
                              onChange={(e) =>
                                this.setState({ Remark: e.target.value })
                              }
                              disabled={this.props.location.state.RoleID===3}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                      {this.props.location.state.RoleID === 3?null:
                        <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={this.handleSubmit}
                            class="btn save_btn"
                          >
                           {CreditNoteID?"Update":"Save"}
                          </a>
                        </div>}
                        <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.backCreditNote()}
                            class="btn back_btn"
                          >
                            Back
                          </a>
                        </div>
                        {/* <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.backDebitNote()}
                            class="btn back_btn"
                          >
                            Order Detail
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <ToastContainer />
            </main>
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    credit_note_add_action,
    credit_note_detail_order_action,
    credit_note_detail_action,
    download_creditNote_action,
  })(AccountCreditNoteAU)
);
